import { render, staticRenderFns } from "./CoinsInstructionsModal.vue?vue&type=template&id=ae71598e&scoped=true&"
import script from "./CoinsInstructionsModal.vue?vue&type=script&lang=ts&"
export * from "./CoinsInstructionsModal.vue?vue&type=script&lang=ts&"
import style0 from "./CoinsInstructionsModal.vue?vue&type=style&index=0&id=ae71598e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae71598e",
  null
  
)

export default component.exports